import {
  Box,
  Stack,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
} from '@chakra-ui/react';
import React from 'react';

import { CreditAgreement } from '@finley-technologies/finley-types';

import { CreditAgreementFullArtifactWipConfigType } from '../../types';
import { LoanProductIntermediateCalcs } from './LoanProductIntermediateCalcs';
import {
  ReceivableAdvanceRateModifiersTable,
  ReceivableAdvanceRateTreeNodes,
} from './LoanProductReceivableAdvanceRateTree';

const tabProps = {
  marginTop: 0,
  marginRight: 0,
  fontSize: 'sm',
  _selected: {
    color: 'blue.400',
    borderBottomColor: 'blue.400',
    borderBottomWidth: '4px',
    boxShadow: 'none',
  },
};

export const ValleyBankAdvanceRate: React.FC<{
  receivableAdvanceRateConfig: CreditAgreement.Config.ReceivableAdvanceRate.Tree;
  basePropertyKey: string;
  idx: number;
  wipConfig?: CreditAgreementFullArtifactWipConfigType;
  loanProductMechanicsConfig: CreditAgreement.Config.LoanProductMechanics.Config;
  loanProductKey: string;
}> = ({
  receivableAdvanceRateConfig,
  basePropertyKey,
  idx,
  wipConfig,
  loanProductMechanicsConfig,
  loanProductKey,
}) => {
  const fullPropertyKey = `${basePropertyKey}[${idx}].receivableAdvanceRate`;

  const baseFields = loanProductMechanicsConfig.baseFieldConfigs;
  const intermediateCalcs = loanProductMechanicsConfig.intermediateCalcConfigs;

  return (
    <Box display="flex" mb="35px" width="100%">
      <Stack width="full">
        <Tabs>
          <TabList>
            <Tab {...tabProps}>Advance Rate</Tab>
            <Tab {...tabProps}>Intermediate Calcs</Tab>
            <Tab {...tabProps}>Modifiers</Tab>
          </TabList>

          <TabPanels>
            <TabPanel>
              <ReceivableAdvanceRateTreeNodes
                advanceRateTreeConfig={receivableAdvanceRateConfig}
                wipConfig={wipConfig}
                fullPropertyKey={`${fullPropertyKey}._config_.receivableAdvanceRateConfig.root`}
                depth={0}
                modifierNames={receivableAdvanceRateConfig.modifiers.map(
                  (m) => m.name,
                )}
                baseFields={baseFields}
                intermediateCalcs={intermediateCalcs}
              />
            </TabPanel>
            <TabPanel>
              <LoanProductIntermediateCalcs
                loanProductKey={loanProductKey}
                config={loanProductMechanicsConfig}
                wipConfig={wipConfig}
                fields={loanProductMechanicsConfig.baseFieldConfigs}
              />
            </TabPanel>
            <TabPanel>
              <ReceivableAdvanceRateModifiersTable
                advanceRateTreeConfig={receivableAdvanceRateConfig}
                fullPropertyKey={`${fullPropertyKey}._config_.receivableAdvanceRateConfig.modifiers`}
                wipConfig={wipConfig}
                baseFields={baseFields}
                intermediateCalcs={intermediateCalcs}
              />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Stack>
    </Box>
  );
};
